import { Pipe, PipeTransform } from '@angular/core';

/**
 * replaces spaces and special characters from string and returns result string.
 */
@Pipe({
    name: 'replaceSpaceCamelCase',
    standalone: false
})
export class ReplaceSpaceCamelCasePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return value
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, '')
      .replace(/[^a-zA-Z ]/g, '');
  }
}
